<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称" prop="companyName">
                <a-input v-model="queryParam.companyName" placeholder="请输入企业名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="企业信用代码" prop="companyNo">
                <a-input v-model="queryParam.companyNo" placeholder="请输入企业信用代码" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态" prop="auditStatus">
                <a-select placeholder="请选择类型" style="width: 100%" v-model="queryParam.auditStatus" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.AuthAuditStatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="法人姓名" prop="legalName">
                <a-input v-model="queryParam.legalName" placeholder="请输入法人姓名" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="法人身份证号" prop="legalIdCardNo">
                <a-input v-model="queryParam.legalIdCardNo" placeholder="请输入法人身份证号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="联系电话" prop="contactPhone">
                <a-input v-model="queryParam.contactPhone" placeholder="请输入联系电话" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="single" @click="$refs.auditForm.handleUpdate(undefined, ids)" v-hasPermi="['user:auth/company:edit']">
          <a-icon type="edit" />批量审核
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:auth/company:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <audit-form
        ref="auditForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="auditStatus" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.AuthAuditStatusEnum" :value="record.auditStatus"/>
        </span>
        <template slot="certImg" slot-scope="text, record">
          <div>
            <img v-if="record.certImg" :src="record.certImg"  style="width:60px;height:62px;" preview="handlePreview"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:auth/company:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.auditStatus===10" v-hasPermi="['user:auth/company:edit']">
            <a-icon type="edit" />审核
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAuthCompany,listAuthCompany, delAuthCompany } from '@/api/user/authCompany'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import AuditForm from "./modules/AuditForm";

export default {
  name: 'AuthCompany',
  components: {
    CustomDictTag,
    CreateForm,
    AuditForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewVisible: false,
      previewAvatar: '',
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        companyName: null,
        companyNo: null,
        legalName: null,
        legalIdCardNo: null,
        contactPhone: null,
        certImg: null,
        auditStatus: null,
        auditReason: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /*{
          title: '用户id ,主键zb_user.id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '企业名称',
          dataIndex: 'companyName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '企业信用代码',
          dataIndex: 'companyNo',
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'contactEmail',
          align: 'center'
        },
        {
          title: '负责人',
          dataIndex: 'contactName',
          align: 'center'
        },
        {
          title: '营业执照图片',
          dataIndex: 'certImg',
          scopedSlots: { customRender: 'certImg' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '主营行业',
          dataIndex: 'companyBusiness',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          scopedSlots: { customRender: 'auditStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核原因',
          dataIndex: 'auditReason',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    /** 查询用户-用户企业认证列表 */
    getList () {
      this.loading = true
     pageAuthCompany(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handlePreview(file) {
      this.previewAvatar = file.url || file.preview;
      this.previewVisible = true;
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        companyName: undefined,
        companyNo: undefined,
        legalName: undefined,
        legalIdCardNo: undefined,
        contactPhone: undefined,
        certImg: undefined,
        auditStatus: undefined,
        auditReason: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids= []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delAuthCompany(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/admin/user/auth-company/export', {
            ...that.queryParam
          }, `用户-用户企业认证_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
